import React from "react";
import { ArrowDown } from "lucide-react";
import CommissionEstimator from "../components/commission/CommissionEstimator";
import Testimonials from "../components/Testimonials";
import { ARTWORKS } from "../data/site";

const HERO = ARTWORKS["black-western"].items.find((a) => a.id === "lady-in-green");

const POLICY = [
  {
    title: "Personal review",
    body: "Every commission is individually reviewed and must be accepted before work begins. The estimator gives a starting range; Joseph confirms final pricing after seeing your concept.",
  },
  {
    title: "Deposit",
    body: "Once accepted, a 50% non-refundable deposit reserves the project and begins the commission process. The remaining 50% is due before delivery or shipment.",
  },
  {
    title: "What's included",
    body: "Shipping, delivery, installation, specialty framing, unusual materials, and commercial or reproduction licensing are not automatically included unless specifically stated in the commission agreement.",
  },
  {
    title: "Rights",
    body: "Purchasing an original artwork does not automatically transfer copyright or reproduction rights. Joseph retains the right to document and share the finished work.",
  },
];

export default function Commissions() {
  return (
    <div data-testid="commissions-page">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-16 md:pb-24 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
        <header className="lg:col-span-7">
          <p className="label mb-4">Private Inquiry</p>
          <h1 className="serif text-5xl md:text-7xl tracking-tight font-light leading-[1.02]">
            Commission an original.
          </h1>
          <p className="mt-6 max-w-2xl text-[hsl(var(--ink-soft))] leading-relaxed text-lg">
            Have an idea for a one-of-a-kind Joseph Graves Jr. original? Tell me
            what you're envisioning and use the estimator below to get a
            starting investment range.
          </p>
          <p className="mt-3 max-w-2xl text-[hsl(var(--ink-soft))] leading-relaxed">
            Every commission is individually reviewed before the project is
            accepted.
          </p>
          <a
            href="#estimator"
            className="mt-10 inline-flex items-center gap-3 bg-foreground text-background px-8 py-4 text-xs uppercase tracking-[0.18em] hover:opacity-90 transition-opacity"
            data-testid="commission-start-button"
          >
            Start your commission
            <ArrowDown className="h-3.5 w-3.5" />
          </a>
        </header>
        <figure className="lg:col-span-5">
          <div className="aspect-[4/5] overflow-hidden bg-[hsl(var(--surface))]">
            <img src={HERO.image} alt={HERO.title} className="w-full h-full object-cover" />
          </div>
          <figcaption className="mt-3 label text-[hsl(var(--ink-soft))]">
            {HERO.title} · {HERO.size} · a recent 48" × 60" original
          </figcaption>
        </figure>
      </section>

      <CommissionEstimator />

      <Testimonials eyebrow="From collectors who commissioned" />

      <section className="border-t border-border bg-[hsl(var(--surface))]" data-testid="how-commissions-work">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
          <header className="mb-12 md:mb-16 max-w-2xl">
            <p className="label mb-3">How commissions work</p>
            <h2 className="serif text-4xl md:text-5xl tracking-tight font-light leading-[1.05]">
              A considered process,{" "}
              <span className="italic text-[hsl(var(--ink-soft))]">start to finish.</span>
            </h2>
          </header>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-10">
            {POLICY.map((p, i) => (
              <div key={p.title} className="border-t border-border pt-5 flex gap-5">
                <span className="serif text-xl text-[hsl(var(--accent))] shrink-0">0{i + 1}</span>
                <div>
                  <p className="serif text-2xl">{p.title}</p>
                  <p className="mt-2 text-sm text-[hsl(var(--ink-soft))] leading-relaxed">{p.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
